const state = {
  vehicleEdit: null,
  vehicleDelete: null
}

export default state